import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

function lockBodyScroll() {
	const body = document.querySelector('body');
	disableBodyScroll(body);
}

function unlockBodyScroll() {
	const body = document.querySelector('body');
	enableBodyScroll(body);
}

document.addEventListener('DOMContentLoaded', function () {
	const isCareersPage = document.querySelector('.careers');
	if (isCareersPage) {
		const jobs = document.querySelectorAll('.job');
		const jobShareCloseBtn = document.querySelector('.job-share-close');
		const jobShareModal = document.querySelector('.job-share');

		if (jobs) {
			jobs.forEach((job) => {
				const jobPreview = job.querySelector('.job-preview');
				const jobToggle = job.querySelector('.job-toggle');
				const jobShareBtn = job.querySelector('.job-actions-share');
				const jobTitle = job.querySelector('h2')?.innerHTML;
				const jobLink = window.location.href + '#' + job.getAttribute('id');

				if (jobPreview && jobToggle) {
					jobToggle.addEventListener('click', function () {
						jobPreview?.classList.toggle('hide');
						if (jobToggle.innerHTML === 'Read more') {
							jobToggle.innerHTML = 'Read less';
						} else {
							jobToggle.innerHTML = 'Read more';
						}
						jobToggle?.toggleAttribute('aria-expanded');
						job.scrollIntoView({ behavior: 'smooth' });
					});
				}

				if (jobShareBtn && jobShareModal) {
					jobShareBtn.addEventListener('click', function () {
						if (navigator.share) {
							navigator.share({
								title: jobTitle,
								text: 'Check out this job on hcma!',
								url: jobLink
							})
							.then(() => {
								job.querySelector('.job-actions-result')?.classList.add('active');
								setTimeout(function () {
									job.querySelector('.job-actions-result')?.classList.remove('active');
								} , 3000);
							})
							.catch(error => console.error('Error sharing:', error));
						} else {
							const emailLink = jobShareModal.querySelector('.email') as HTMLAnchorElement;
							const twitterLink = jobShareModal.querySelector('.twitter') as HTMLAnchorElement;
							const facebookLink = jobShareModal.querySelector('.facebook') as HTMLAnchorElement;
							const linkedinLink = jobShareModal.querySelector('.linkedin') as HTMLAnchorElement;

							if (emailLink && twitterLink && facebookLink && linkedinLink && jobLink && jobTitle) {
								emailLink.href = 'mailto:?subject=Job%20Posting:%20' + encodeURIComponent(jobTitle) + '&body=Check%20out%20this%20opportunity%20with%20hcma!%20' + encodeURIComponent(jobLink);
								twitterLink.href = 'http://twitter.com/intent/tweet?text=' + encodeURIComponent(jobTitle) + '+' + encodeURIComponent(jobLink) + '+via+%40hcma';
								facebookLink.href = 'http://www.facebook.com/sharer.php?u=' + encodeURIComponent(jobLink);
								linkedinLink.href = 'http://www.linkedin.com/sharing/share-offsite/?url=' + jobLink;
							}

							jobShareModal.classList.add('active');
							lockBodyScroll();
						}
					});

					if (jobShareCloseBtn) {
						jobShareCloseBtn.addEventListener('click', function () {
							if (jobShareModal) {
								jobShareModal.classList.remove('active');
								unlockBodyScroll();
							}
						});
					}
				}
			});
		}
	}
});